import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { doctorActions, patientActions, ehrActions } from "../core/actions";
import TextField from "@mui/material/TextField";
import { makeStyles } from "@material-ui/core";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";
import { CASERECORD } from "../shared/constants";
import { format } from "date-fns";
import CloseIcon from "@mui/icons-material/Close";
import IconButton from "@mui/material/IconButton";
import { Alert } from "@mui/material";
import { helperServices } from "../shared/helper";
import PrintIcon from "@mui/icons-material/Print";
import { openDoctorPrint } from "./VedamaayuDoctorPrint";

function VedamaayuDoctorNotes(props) {
    const dispatch = useDispatch();
    const noteSubgroup = props.noteSubgroup || "doctor";
    const isReadOnly = Boolean(props.readOnly);
    const showOnlyDoctorNotes = Boolean(props.showOnlyDoctorNotes);
    const [followUpDateFlag, setFollowUpDateFlag] = useState(false);
    const inputRefs = useRef([]);
    const [status, setStatus] = useState(undefined);
    const [todayDate, setTodayDate] = useState(new Date());
    const [revisitDate, setRevisitDate] = useState(
        format(new Date().setDate(new Date().getDate() + 14), "yyyy-MM-dd")
    );
    const [diagnosistemplate, setDiagnosistemplate] = useState();
    const [followUpdateFlag, setFollowUpdateFlag] = useState(true);
    const [patientDetail, setPatientDetail] = useState({
        patientId: "",
        lastvisitId: "",
        scheduleddate: "",
    });

    const [notes, setNotes] = useState({
        "Comment": "",
        "Follow Up Date For Vedamaayu": "",
        "Chief Complaint": "",
        "Present History": "",
        "Past History": "",
        "Personal History": "",
        "Menstrual Details": "",
        "Appetite": "",
        "Micturition": "",
        "Bowel": "",
        "Sleep": "",
        "Family History": "",
        "General Systemic Examination": "",
        "Allergies Adverse Reaction": "",
        "Allergies Adverse Reaction Details": "",
        "Vulnerable Patient Doctor": "",
        "Vulnerable Patient Details": "",
        "Lab Investigation": "",
        "Treatment History": "",
        "Diagnosis": "",
        "Doctor Notes": "",
        "Doctor Temp": "",
        "Doctor BP": "",
        "Doctor Pulse": "",
        "Doctor Height": "",
        "Doctor Weight": "",
    });

    const [showError, setShowError] = useState(false);
    const [ServerRes, setServerRes] = useState({ success: "", error: "" });
    const [loadsummary, setLoadSummary] = useState(false);
    const patientEhrid = useSelector((state) => state.patientDetailsState.ehrid);
    const [formErrors, setFormErrors] = useState({ "Comment": "" });
    const [filterdProList, setfilterdProList] = useState();
    const [selectedDoctor, setSelectedDoctor] = useState("");
    const [selectedDoctorDepartment, setSelectedDoctorDepartment] = useState("");

    const useStyles = makeStyles((theme) => ({
        redAsterisk: { color: "red" },
    }));
    const classes = useStyles();

    useEffect(() => {
        console.log("props data is : ", props);
        let patientId = props.patientData.id;
        let visitId = props.patientData.visit.id;
        dispatch(
            patientActions.getrevisitbyId(patientId, visitId, (resCb) => {
                if (resCb) {
                    console.log("resCb doctor Response:", resCb);
                    patientDetail["scheduleddate"] = resCb.scheduleddate;
                    if (
                        patientDetail["scheduleddate"] !== " " &&
                        patientDetail["scheduleddate"] !== undefined &&
                        patientDetail["scheduleddate"] !== null
                    ) {
                        setRevisitDate(
                            format(new Date(patientDetail["scheduleddate"]), "yyyy-MM-dd")
                        );
                    } else {
                        setRevisitDate(
                            format(new Date().setDate(new Date().getDate() + 14), "yyyy-MM-dd")
                        );
                    }
                }
            })
        );
        getNotesDetails();
        getDiagnosistemplateById();
    }, []);

    const getNotesDetails = () => {
        props.patientData.patientId = props.patientData.id;
        props.patientData.visitId = props.patientData.visit.id;
        props.patientData.groupname = CASERECORD;
        console.log("details :: ", props.patientData);
        const selectedCaseRecordIds =
            props.selectedProcedure?.caseRecordGroup?.map((item) => String(item.id)) || [];
        dispatch(
            patientActions.getDischargeSummary(notes, props.patientData, (resCb) => {
                if (resCb) {
                    console.log("resCb doctor Response:", resCb);
                    if (resCb.procedureList) {
                        const filterList = resCb.procedureList.filter(
                            (items) =>
                                items.groupname === CASERECORD &&
                                items.subgroup === noteSubgroup &&
                                (
                                    selectedCaseRecordIds.length === 0 ||
                                    selectedCaseRecordIds.includes(String(items.id))
                                )
                        );
                        const keys = Object.keys(notes);
                        var patientNotes = { ...notes };
                        var filteredProList = [];
                        filterList.forEach((item) => {
                            for (let key of keys) {
                                if (item.claSS == key) {
                                    patientNotes[key] = item.notes;
                                    filteredProList.push(item);
                                    setNotes({ ...patientNotes });
                                }
                            }
                            setfilterdProList([...filteredProList]);
                        });
                    }
                    if (resCb && resCb.vaList && resCb.vaList[0]) {
                        console.log("resCb.vaList[0]", resCb.vaList[0].targetid);
                        getDoctorsList(resCb.vaList[0].targetid);
                    }
                }
            })
        );
    };

    const closeServiceModal = (event) => {
        props.onModalClose(event);
    };

    const saveDiagnosisinEHR = (finaldiagnosis) => {
        let templateId = "Diagnosis";
        let patientId = props.patientData.id;
        let visitId = props.patientData.visit.id;
        console.log("Templateiddddd", diagnosistemplate.content[0].data);
        diagnosistemplate.content[0].subject.name = selectedDoctor;
        for (let item of diagnosistemplate.content[0].data.items) {
            let element = item.name.value;
            const time = new Date(
                new Date().toLocaleString("en-US", { timeZone: "Asia/Kolkata" })
            ).toISOString();
            switch (element) {
                case "Problem/Diagnosis name": item.value.value = "Diagnosis"; break;
                case "Clinical description": item.value.value = finaldiagnosis.notes; break;
                case "Date/time of onset": item.value.value = time; break;
                case "Date/time of resolution": item.value.value = time; break;
                case "Date/time clinically recognised": item.value.value = time; break;
                default:
            }
        }
        let notesDetails = finaldiagnosis.notes ? finaldiagnosis.notes : "NA";
        let procedure = props.selectedProcedure ?? null;
        dispatch(
            ehrActions.saveComposition(
                diagnosistemplate, patientId, visitId, templateId,
                patientEhrid, notesDetails, procedure,
                (resCb) => {
                    if (resCb) {
                        if (resCb.successMessages) {
                            props.onModalClose({ success: resCb.successMessages[0] });
                        } else {
                            if (resCb.errorMessages[0]) {
                                props.onModalClose({ error: resCb.errorMessages[0] });
                            }
                        }
                    }
                }
            )
        );
    };

    const getDiagnosistemplateById = () => {
        let templateId = "Diagnosis";
        dispatch(
            ehrActions.getTemplateById("", templateId, {}, (resCb) => {
                if (resCb) {
                    console.log("Getdiagnosiss rescb", resCb);
                    setDiagnosistemplate(resCb);
                }
            })
        );
        return diagnosistemplate;
    };

    const handleInputChange = (name, value) => {
        if (isReadOnly) return;
        setShowError(false);
        console.log("In handleinput change", name, value);
        let updatedFormErrors = { ...formErrors };
        if (name === "Comment" && value.length > 800) {
            updatedFormErrors[name] = name + " exceeds limit of 800 characters";
        } else {
            updatedFormErrors[name] = "";
        }
        setFormErrors(updatedFormErrors);
        formErrors[name] = "";
        const clearVulnerableDetails =
            name === "Vulnerable Patient Doctor" && value !== "Yes";

        setfilterdProList((currentList) =>
            currentList?.map((item) => {
                if (item.claSS === name) {
                    return { ...item, notes: value };
                }
                if (
                    clearVulnerableDetails &&
                    item.claSS === "Vulnerable Patient Details"
                ) {
                    return { ...item, notes: "" };
                }
                return item;
            })
        );

        setNotes((currentNotes) => ({
            ...currentNotes,
            [name]: value,
            ...(clearVulnerableDetails
                ? { "Vulnerable Patient Details": "" }
                : {}),
        }));
    };

    const handleSubmit = (e) => {
        validateForm(e);
        setTimeout(() => { console.log("props:", props); }, 3000);
    };

    const setMessageStrip = (e) => {
        console.log("message obtained", e);
        var ServerResVal = ServerRes;
        if (e.success) { ServerResVal.success = e.success; }
        else { ServerResVal.error = e.error; }
        setServerRes({ ...ServerResVal });
        setTimeout(() => { closeAlert(); }, 5000);
    };

    const UpdateRevisitDetails = () => {
        console.log(" insert  props", props);
        patientDetail.patientId = props.patientData.id;
        patientDetail.lastvisitId = props.patientData.visit.id;
        console.log("patientdetail.....", patientDetail, revisitDate);
        let date = format(new Date(revisitDate), "dd-MM-yyyy");
        notes["Follow Up Date For Vedamaayu"] = date;
        patientDetail.scheduleddate = date;
        setFollowUpdateFlag(date);
        console.log("notes adte:", notes["Follow Up Date For Vedamaayu"]);
        return patientDetail;
    };

    const closeAlert = (e) => {
        setServerRes({ ..."" });
    };

    const validateForm = (e) => {
        if (isReadOnly) {
            e.preventDefault();
            return;
        }
        console.log("Submit Notes:", e);
        console.log("formErrors : ", formErrors);
        for (let key in formErrors) {
            if (formErrors[key] !== "") {
                setMessageStrip({ error: "Please check there is a validation error in the notes form" });
                return;
            }
        }
        setShowError(false);
        var ServerResVal = ServerRes;
        e.preventDefault();
        var proList = [];
        let finaldiagnosis = {};
        const followUpDetails = UpdateRevisitDetails();
        const keys = Object.keys(notes);

        for (let key of keys) {
            const existingItem = filterdProList?.find(
                (item) => item.claSS === key
            );

            const noteValue =
                key === "Follow Up Date For Vedamaayu"
                    ? followUpDetails.scheduleddate
                    : notes[key];

            proList.push({
                ...(existingItem?.id ? { id: existingItem.id } : {}),
                claSS: key,
                notes: noteValue,
                patientId:
                    existingItem?.patientId || props.patientData.id,
                visitId:
                    existingItem?.visitId || props.patientData.visit.id,
                subgroup: "doctor",
            });
        }
        notes["notes"] = "NOTE";

        dispatch(
            doctorActions.addCaseRecord(proList, (resCb) => {
                if (resCb) {
                    console.log("resCb doctor Response:", resCb);
                    if (resCb.successMessages) {
                        if (finaldiagnosis && finaldiagnosis.notes !== "" && finaldiagnosis.notes !== undefined) {
                            saveDiagnosisinEHR(finaldiagnosis);
                        }
                        props.onModalClose({ success: "Notes added successfully" });
                    } else {
                        props.onModalClose({ error: "Failed to add notes" });
                    }
                    console.log("resCbe : ", resCb);
                }
            })
        );
        setMessageStrip({ success: e.successMessages });
        setServerRes({ ...ServerResVal });
        setTimeout(() => { closeAlert(); }, 3000);
    };

    const ChangeRevisitDate = (event) => {
        console.log("date: ", event.target.value);
        setRevisitDate(event.target.value);
    };

    const getDoctorsList = (targetid, data) => {
        dispatch(
            doctorActions.getDoctorList(data, (resCb) => {
                if (resCb) {
                    for (let doc of resCb) {
                        if (doc != null) {
                            if (!doc.first_name) doc.first_name = "";
                            if (!doc.last_name) doc.last_name = "";
                            const name = helperServices.getFullName(doc.first_name, null, doc.last_name);
                            if (
                                targetid &&
                                [doc.personId, doc.gvId, doc.gvid].some(
                                    (id) =>
                                        id !== null &&
                                        id !== undefined &&
                                        String(id) === String(targetid)
                                )
                            ) {
                                setSelectedDoctor(
                                    [doc.displaytitle ? `${doc.displaytitle}.` : "", name]
                                        .filter(Boolean)
                                        .join(" ")
                                );
                                setSelectedDoctorDepartment(doc.department || "");
                            }
                        }
                    }
                }
            })
        );
    };

    return (
        <>
            {ServerRes.error && (
                <Alert severity="error" className="alert-div">
                    {ServerRes.error}{" "}
                    <IconButton aria-label="close" color="inherit" size="small" onClick={(e) => closeAlert(e)}>
                        <CloseIcon fontSize="inherit" />
                    </IconButton>
                </Alert>
            )}

            <div className="bg-none nav-wrapper h-100 d-flex flex-column service-view">
                <div className='"d-flex'>
                    <IconButton
                        aria-label="close"
                        onClick={(event) => closeServiceModal(event)}
                        sx={{ position: "absolute", right: 8, top: 8, color: (theme) => theme.palette.grey[500] }}
                    >
                        <CloseIcon />
                    </IconButton>
                </div>

                <div className="w-100 service-container service-container1" style={{ overflowY: "auto" }}>
                    <div className="d-flex m-3 justify-content-between px-4">
                        <div className="w-100 flex-wrap flex-column">

                            {showError && (
                                <div className="text-danger my-4">All fields can not be empty!</div>
                            )}



                            <fieldset disabled={isReadOnly} style={{ border: 0, padding: 0, margin: 0 }}>
                                <Box className="row service-form mb-4">
                                    {!showOnlyDoctorNotes && (
                                        <>
                                <div className="col-12 mb-1"><small><strong>History</strong></small></div>

                                <div id="notespadding" className="pl-0 col-lg-6 col-xl-6 col-md-6 col-12 pt-2">
                                    <TextField fullWidth className="p-2" value={notes["Chief Complaint"]}
                                        placeholder="Chief Complaint..." autoComplete="off"
                                        onChange={(e) => handleInputChange("Chief Complaint", e.target.value)}
                                        label="Pradhana Vedana (Chief Complaint)" multiline minRows={1} maxRows={6} />
                                </div>

                                <div id="notespadding" className="pl-0 col-lg-6 col-xl-6 col-md-6 col-12 pt-2">
                                    <TextField fullWidth className="p-2" value={notes["Present History"]}
                                        placeholder="Present History..." autoComplete="off"
                                        onChange={(e) => handleInputChange("Present History", e.target.value)}
                                        label="Pradhana Vedana Vrittanta (Present History)" multiline minRows={1} maxRows={6} />
                                </div>

                                <div id="notespadding" className="pl-0 col-lg-6 col-xl-6 col-md-6 col-12 pt-2">
                                    <TextField fullWidth className="p-2" value={notes["Past History"]}
                                        placeholder="Past History..." autoComplete="off"
                                        onChange={(e) => handleInputChange("Past History", e.target.value)}
                                        label="Poorva Vyadhi Vrittanta (Past History)" multiline minRows={1} maxRows={6} />
                                </div>

                                <div id="notespadding" className="pl-0 col-lg-6 col-xl-6 col-md-6 col-12 pt-2">
                                    <TextField fullWidth className="p-2" value={notes["Personal History"]}
                                        placeholder="Personal History..." autoComplete="off"
                                        onChange={(e) => handleInputChange("Personal History", e.target.value)}
                                        label="Vayaktika Vrittanta (Personal History)" multiline minRows={1} maxRows={6} />
                                </div>
                                <div className="col-12 mt-3 mb-1"><small><strong>Personal History Details</strong></small></div>

                                {["Appetite", "Micturition", "Bowel", "Sleep"].map((field) => (
                                    <div key={field} id="notespadding" className="pl-0 col-lg-3 col-xl-3 col-md-3 col-6 pt-2">
                                        <TextField fullWidth className="p-2" value={notes[field]}
                                            placeholder={field} autoComplete="off"
                                            onChange={(e) => handleInputChange(field, e.target.value)}
                                            label={field} />
                                    </div>
                                ))}
                                {["f", "female"].includes(
                                    String(
                                        props.patientData?.sex ||
                                            props.patientData?.gender ||
                                            ""
                                    ).trim().toLowerCase()
                                ) && (
                                    <div id="notespadding" className="pl-0 col-12 pt-2">
                                        <TextField
                                            fullWidth
                                            className="p-2"
                                            value={notes["Menstrual Details"]}
                                            placeholder="Enter menstrual details..."
                                            autoComplete="off"
                                            onChange={(e) =>
                                                handleInputChange("Menstrual Details", e.target.value)
                                            }
                                            label="Menstrual Details"
                                            multiline
                                            minRows={2}
                                            maxRows={6}
                                        />
                                    </div>
                                )}

                                <div className="col-12 mt-3 mb-1"><small><strong>Family History</strong></small></div>
                                <div id="notespadding" className="pl-0 col-12 pt-2">
                                    <TextField fullWidth className="p-2" value={notes["Family History"]}
                                        placeholder="Family History..." autoComplete="off"
                                        onChange={(e) => handleInputChange("Family History", e.target.value)}
                                        label="Family History" multiline minRows={1} maxRows={6} />
                                </div>

                                <div className="col-12 mt-3 mb-1"><small><strong>General & Systemic Examination — Vitals</strong></small></div>

                                {[["Doctor Temp", "Temp"], ["Doctor BP", "BP"], ["Doctor Pulse", "Pulse"], ["Doctor Height", "Height"], ["Doctor Weight", "Weight"]].map(([key, label]) => (
                                    <div key={key} id="notespadding" className="pl-0 col-lg-2 col-xl-2 col-md-3 col-6 pt-2">
                                        <TextField fullWidth className="p-2" value={notes[key]}
                                            placeholder={label} autoComplete="off"
                                            onChange={(e) => handleInputChange(key, e.target.value)}
                                            label={label} />
                                    </div>
                                ))}

                                <div id="notespadding" className="pl-0 col-12 pt-2">
                                    <TextField fullWidth className="p-2" value={notes["General Systemic Examination"]}
                                        placeholder="Examination findings..." autoComplete="off"
                                        onChange={(e) => handleInputChange("General Systemic Examination", e.target.value)}
                                        label="General & Systemic Examination Notes" multiline minRows={2} maxRows={6} />
                                </div>

                                <div className="col-12 mt-3 mb-1"><small><strong>Clinical Flags</strong></small></div>

                                <div id="notespadding" className="pl-0 col-lg-3 col-md-4 col-6 pt-2">
                                    <label className="service-lable mb-1">Allergies / Adverse Reaction</label>
                                    <select className="form-control filterin Quantity"
                                        value={notes["Allergies Adverse Reaction"]}
                                        onChange={(e) => handleInputChange("Allergies Adverse Reaction", e.target.value)}>
                                        <option value="">-- Select --</option>
                                        <option value="Yes">Yes</option>
                                        <option value="No">No</option>
                                    </select>
                                </div>

                                {notes["Allergies Adverse Reaction"] === "Yes" && (
                                    <div id="notespadding" className="pl-0 col-lg-6 col-md-6 col-12 pt-2">
                                        <TextField fullWidth className="p-2" value={notes["Allergies Adverse Reaction Details"]}
                                            placeholder="Allergy details..." autoComplete="off"
                                            onChange={(e) => handleInputChange("Allergies Adverse Reaction Details", e.target.value)}
                                            label="If Yes — Allergy Details" multiline minRows={1} maxRows={4} />
                                    </div>
                                )}

                                <div id="notespadding" className="pl-0 col-lg-3 col-md-4 col-6 pt-2">
                                    <label className="service-lable mb-1">Vulnerable Patient</label>
                                    <select className="form-control filterin Quantity"
                                        value={notes["Vulnerable Patient Doctor"]}
                                        onChange={(e) => handleInputChange("Vulnerable Patient Doctor", e.target.value)}>
                                        <option value="">-- Select --</option>
                                        <option value="Yes">Yes</option>
                                        <option value="No">No</option>
                                    </select>
                                </div>

                                {notes["Vulnerable Patient Doctor"] === "Yes" && (
                                    <div id="notespadding" className="pl-0 col-lg-6 col-md-6 col-12 pt-2">
                                        <TextField
                                            fullWidth
                                            className="p-2"
                                            value={notes["Vulnerable Patient Details"]}
                                            placeholder="Vulnerability details..."
                                            autoComplete="off"
                                            onChange={(e) =>
                                                handleInputChange("Vulnerable Patient Details", e.target.value)
                                            }
                                            label="If Yes - Vulnerability Details"
                                            multiline
                                            minRows={1}
                                            maxRows={4}
                                        />
                                    </div>
                                )}

                                <div className="col-12 mt-3 mb-1"><small><strong>Investigations & Treatment</strong></small></div>

                                <div id="notespadding" className="pl-0 col-lg-6 col-xl-6 col-md-6 col-12 pt-2">
                                    <TextField fullWidth className="p-2" value={notes["Lab Investigation"]}
                                        placeholder="Lab Investigation..." autoComplete="off"
                                        onChange={(e) => handleInputChange("Lab Investigation", e.target.value)}
                                        label="Lab Investigation" multiline minRows={2} maxRows={6} />
                                </div>

                                <div id="notespadding" className="pl-0 col-lg-6 col-xl-6 col-md-6 col-12 pt-2">
                                    <TextField fullWidth className="p-2" value={notes["Treatment History"]}
                                        placeholder="Treatment History..." autoComplete="off"
                                        onChange={(e) => handleInputChange("Treatment History", e.target.value)}
                                        label="Chikitsa Vrittanta (Treatment History)" multiline minRows={2} maxRows={6} />
                                </div>

                                <div id="notespadding" className="pl-0 col-12 pt-2">
                                    <TextField
                                        fullWidth
                                        className="p-2"
                                        value={notes["Diagnosis"]}
                                        placeholder="Diagnosis..."
                                        autoComplete="off"
                                        onChange={(e) =>
                                            handleInputChange("Diagnosis", e.target.value)
                                        }
                                        label="Vyadhi Vinishchaya (Diagnosis)"
                                        multiline
                                        minRows={2}
                                        maxRows={6}
                                    />
                                </div>
                                        </>
                                    )}

                                <div id="notespadding" className="pl-0 col-12 pt-2">
                                    <TextField
                                        fullWidth
                                        className="p-2"
                                        value={notes["Doctor Notes"]}
                                        placeholder="Enter doctor notes..."
                                        autoComplete="off"
                                        onChange={(e) =>
                                            handleInputChange("Doctor Notes", e.target.value)
                                        }
                                        label="Doctor Notes"
                                        multiline
                                        minRows={5}
                                        maxRows={12}
                                    />
                                </div>

                                </Box>
                            </fieldset>

                            <div className="d-flex align-items-center gap-2 my-4">
                                {!isReadOnly && (
                                    <Button
                                        id="we" type="submit" color="primary" variant="contained"
                                        sx={{ textTransform: "capitalize" }}
                                        className="btn-primary"
                                        onClick={(event) => handleSubmit(event)}
                                    >
                                        Save
                                    </Button>
                                )}
                                <Button
                                    variant="contained"
                                    color="primary"
                                    startIcon={<PrintIcon />}
                                    sx={{ textTransform: "capitalize" }}
                                    onClick={() => {
                                        const assessmentCreatedDate =
                                            props.selectedProcedure?.caseRecordGroup?.find(
                                                (item) => item?.cdt
                                            )?.cdt ||
                                            props.selectedProcedure?.cdt ||
                                            filterdProList?.find((item) => item?.cdt)?.cdt;

                                        openDoctorPrint(notes, props.patientData, {
                                            doctorName: selectedDoctor,
                                            department: selectedDoctorDepartment,
                                            assessmentDate: assessmentCreatedDate,
                                        });
                                    }}
                                >
                                    Print
                                </Button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default VedamaayuDoctorNotes;
